var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeader = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60156 2.66823L1.60156 7.29045L14.4016 7.29045L14.4016 2.66823C14.4016 2.07913 13.924 1.60156 13.3349 1.60156L2.66823 1.60156C2.07913 1.60157 1.60156 2.07913 1.60156 2.66823Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31267 14.4016C1.91994 14.4016 1.60156 14.0832 1.60156 13.6905L1.60156 12.2682H3.02378L3.02379 12.9793H3.7349L3.7349 14.4016H2.31267Z",
    fill: "#5C5F62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4016 13.6905C14.4016 14.0832 14.0832 14.4016 13.6905 14.4016H12.2682L12.2682 12.9793H12.9793L12.9793 12.2682H14.4016V13.6905Z",
    fill: "#5C5F62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60156 10.846L1.60156 8.71267H3.02379L3.02379 10.846H1.60156Z",
    fill: "#5C5F62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9793 8.71267V10.846H14.4016V8.71267H12.9793Z",
    fill: "#5C5F62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15712 12.9793H7.29045V14.4016H5.15712L5.15712 12.9793Z",
    fill: "#5C5F62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.846 12.9793H8.71267V14.4016H10.846V12.9793Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeader, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/header.35d3c705.svg";
export { ForwardRef as ReactComponent };